module.exports = __webpack_public_path__ + "img/karakters-12.5f21c341.jpg";